import { toast } from "react-toastify";
import moment from "moment";
import _ from 'lodash';
export const getRandomNumber = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min + 1;
};

export const getQueryParam = (searchedQuery, key) => {
  const query = new URLSearchParams(searchedQuery);
  return query.get(key);
};

export const isDate = (value) => {
  return moment(value).isValid();
};
export const copyToClipboard = (str) => {
  const el = document.createElement("textarea"); // Create a <textarea> element
  el.value = str; // Set its value to the string that you want copied
  el.setAttribute("readonly", ""); // Make it readonly to be tamper-proof
  el.style.position = "absolute";
  el.style.left = "-9999px"; // Move outside the screen to make it invisible
  document.body.appendChild(el); // Append the <textarea> element to the HTML document
  const selected =
    document.getSelection().rangeCount > 0 // Check if there is any content selected previously
      ? document.getSelection().getRangeAt(0) // Store selection if found
      : false; // Mark as false to know no selection existed before
  el.select(); // Select the <textarea> content
  document.execCommand("copy"); // Copy - only works as a result of a user action (e.g. click events)
  document.body.removeChild(el); // Remove the <textarea> element
  if (selected) {
    // If a selection existed before copying
    document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
    document.getSelection().addRange(selected); // Restore the original selection
  }
  showToastMessage("success", "Code copied successfully.");
};

export const breakString = (str, char) => {
  return str.split(char);
};

export const fetchRemoteConfig = async (key) => {
  let isMaintenance = false;
  const response = await window.remoteConfig
    .fetchAndActivate()
    .then((response) => {
      var maintenance = window.remoteConfig.getValue("web_maintenance");
      isMaintenance = JSON.parse(maintenance._value)[key];
      return isMaintenance;
    })
    .catch((err) => {
      console.error(err);
    });
  return response;
};
export const fetchRemoteConfiguration = async (key) => {
  const response = await window.remoteConfig
    .fetchAndActivate()
    .then((response) => {
      var maintenance = window.remoteConfig.getValue(key);
      return JSON.parse(maintenance._value);
    })
    .catch((err) => {
      console.error(err);
    });
  return response;
};

export const showToastMessage = (type, message) => {
  toast[type](message, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
};

export const reverseDateFormat = (value) => {
  if (value) {
    return value
      .split("-")
      .reverse()
      .join("-");
  }
};

export const replaceAt = (array, index, value) => {
  const ret = array.slice(0);
  ret[index] = value;
  return ret;
};
export const createCookie = (name, value, days) => {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else expires = "";
  document.cookie = name + "=" + value + expires;
  // document.cookie = name+"="+value+expires+"; path=/";
};
export const readCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const currentlySelectedLanguage = () => {
  const language = readCookie("windsEWorldAppLanguageCode") || "en";
  return language;
};

export const shuffle = (o) => {
  for (
    var j, x, i = o.length;
    i;
    j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x
  );
  return o;
};

// export const filter = (data,rule,identifier,property) => {
// return data.filter(item=>item[property] [rule] identifier )
// }
export const sortDateOrderByDescending = (seriesRawDataArray,timestamp) => {
  const sortedArray = _.orderBy(seriesRawDataArray, [(data) => data[timestamp]], ['desc']);
  return sortedArray; 
}
